import { useI18n } from '../i18n';

/**
 * The PT / EN language switch — a compact two-button toggle matching the site's
 * minimal header. Reads and updates the shared i18n store.
 */
export const LanguageToggle = () => {
  const { locale, setLocale } = useI18n();
  return (
    <div className="lang">
      <button
        type="button"
        className={locale === 'pt' ? 'active' : ''}
        onClick={() => setLocale('pt')}
        aria-pressed={locale === 'pt'}
      >
        PT
      </button>
      <span aria-hidden="true">/</span>
      <button
        type="button"
        className={locale === 'en' ? 'active' : ''}
        onClick={() => setLocale('en')}
        aria-pressed={locale === 'en'}
      >
        EN
      </button>
    </div>
  );
};
